// src/stone/icons/Email2X.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Email2X = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M6.667 7.667A2.343 2.343 0 0 0 4.333 10v20a2.343 2.343 0 0 0 2.334 2.333h26.666A2.343 2.343 0 0 0 35.667 30V10a2.343 2.343 0 0 0-2.334-2.333zM2.333 10a4.343 4.343 0 0 1 4.334-4.333h26.666A4.343 4.343 0 0 1 37.667 10v20a4.343 4.343 0 0 1-4.334 4.333H6.667A4.343 4.343 0 0 1 2.333 30z" }),
      /* @__PURE__ */ jsx("path", { d: "M2.514 9.427a1 1 0 0 1 1.393-.246L20 20.446 36.093 9.181a1 1 0 1 1 1.147 1.638L20.573 22.486a1 1 0 0 1-1.146 0L2.76 10.819a1 1 0 0 1-.246-1.392" })
    ]
  }
);
var Email2X_default = Email2X;

export {
  Email2X_default
};
